import styled from 'styled-components';

export const DesktopComponentContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: max-content;
`;

export const DesktopComponentMainImageContainer = styled.div`
  display: flex;
  position: relative;
  position: ${(props) => (props.isCustomWebsite ? 'sticky' : 'relative')};
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const DesktopComponentMainVideoContainer = styled.div`
  height: ${(props) => {
    return props.imageDimensions?.height === 'auto'
      ? '480px'
      : props.imageDimensions?.height;
  }};
  width: ${(props) => props.imageDimensions?.width};
`;

export const SideImagePanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 48px;
`;

export const SidePanelImage = styled.img`
  width: ${(props) => props.thumbnailImageDimensions?.width};
  height: ${(props) => props.thumbnailImageDimensions?.height};
  margin-bottom: 16px;
  cursor: pointer;
  ${(props) => (props?.isSelected ? 'border : 0.6px solid #858585' : '')};
`;

export const SidePanelVideo = styled.div`
  width: ${(props) => props.thumbnailImageDimensions?.width};
  height: ${(props) => props.thumbnailImageDimensions?.height};
  margin-bottom: 16px;
  cursor: pointer;
  ${(props) => (props?.isSelected ? 'border : 0.6px solid #858585' : '')};
`;

export const SidePanelLastMaskContainer = styled.div`
  width: ${(props) => props.thumbnailImageDimensions?.width};
  height: ${(props) => props.thumbnailImageDimensions?.height};
`;
export const SidePanelLastMask = styled.div`
  width: ${(props) => props.thumbnailImageDimensions?.width};
  height: ${(props) => props.thumbnailImageDimensions?.height};
  position: absolute;
  display: flex;
  color: white;
  justify-content: center;
  align-items: center;
  background: black;
  opacity: 0.59;
`;

export const MainImageVideoIconContainer = styled.div`
  display: flex;
  position: absolute;
  width: inherit;
  height: inherit;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const MagnifyImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
export const ShareActionsContainer = styled.div`
  position: absolute;
  right: 8px;
  height: 100%;
`;
export const ShareIconContainer = styled.span`
  position: absolute;
  cursor: pointer;
  top: ${(props) => (props.top ? props.top : '62px')};
  right: 8px;
  z-index: 999;
  width: 32px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  background: white;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* box-shadow:
    1px 1px 4px 0px rgba(0, 0, 0, 0.12),
    -1px -1px 4px 0px rgba(0, 0, 0, 0.12); */
`;
export const ShareOptionsContainer = styled.div`
  width: 156px;
  border-radius: 8px;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 1);
  /* height: 272px; */
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 999;
  height: auto;
  display: flex;
  flex-direction: column;
`;
export const SharOptionsBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  border-bottom: ${(props) =>
    props.lastIdx === 5 ? '0' : '1px solid rgba(0, 0, 0, 0.2)'};
`;
export const SharOptionsSection = styled.div`
  padding: 0 0.75rem;
  width: 100%;
  display: flex;
  gap: 12px;
  cursor: pointer;
`;
export const PortalContainer = styled.span`
  color: ${({ portal }) =>
    portal === 'Link Copied' ? 'rgba(43, 116, 216, 1)' : 'black'};
`;
